import { LoadIntegrationsQuery } from "~/operations";

export type Integration = NonNullable<LoadIntegrationsQuery["integrations"][0]>;

export enum ChatIntegrationName {
  Msteams = "msteams",
  Slack = "slack",
  Telegram = "telegram",
  Httppost = "httppost",
}
